<div class="modal-container">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" ngbAutofocus>
            {{ "check_list_detail" | lang | uppercase }}
        </h4>
        <button type="button" class="close" aria-p="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">
            <div class="col-5">
                <p>
                    <span>
                        <label class="detail-value"
                            >{{ "machine_name" | lang | titlecase }}:
                        </label>
                        <label class="detail-info">{{
                            checkList.machineName
                        }}</label>
                    </span>
                </p>
                <p>
                    <span>
                        <label class="detail-value"
                            >{{ "createdat" | lang | titlecase }}:
                        </label>
                        <label class="detail-info"
                            >{{ checkList.createAt | dateTimePresentation }}
                        </label>
                    </span>
                </p>
            </div>
            <div class="col-5">
                <p>
                    <span>
                        <label class="detail-value"
                            >{{ "shift_" | lang | titlecase }}:
                        </label>
                        <label class="detail-info">{{
                            checkList.shiftName
                        }}</label>
                    </span>
                </p>
                <p>
                    <span>
                        <label class="detail-value"
                            >{{ "operator" | lang | titlecase }}:
                        </label>
                        <label class="detail-info">{{
                            checkList.operatorName
                        }}</label>
                    </span>
                </p>
            </div>
            <div class="col-2">
                <app-button-icon
                    [image]="'download'"
                    iconType="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (click)="download()"
                ></app-button-icon>
            </div>
        </div>

        <div class="table-container">
            <table
                class="mt-table mt-table-striped sticky"
                aria-label="table-checklist-modal"
            >
                <thead>
                    <tr>
                        <th scope="col" class="desc">
                            <span class="header-title">{{
                                "description" | lang
                            }}</span>
                        </th>
                        <th
                            scope="col"
                            class="option"
                            *ngFor="let o of checkList.checklistOptionList"
                        >
                            <span class="header-title">{{
                                o.checklistOptionDescription
                            }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let d of checkList.checklistDetail">
                        <td class="desc">{{ d.checklistItem }}</td>
                        <td
                            class="option"
                            *ngFor="let op of checkList.checklistOptionList"
                        >
                            <span
                                class="dot"
                                [ngClass]="
                                    op.checklistOptionDescription | lowercase
                                "
                                *ngIf="
                                    d.checklistOption ===
                                    op.checklistOptionDescription
                                "
                            ></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal-footer"></div>
</div>
